export const TICKET_MESSAGE_MAX_LENGTH = 3000;
export const TICKET_MESSAGE_LENGTH_ERROR = "حداکثر ۳۰۰۰ کاراکتر مجاز است";
